import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import CreateReportMutation from '../../../../../../mutations/CreateReportMutation';

const initialState = {
  name: '',
};

const styles = {
  reportNameInput: {
    width: 500,
  },
};

class CreateReportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, initialState);
  }

  updateName = (event, value) => {
    this.setState({name: value});
  };

  save = () => {
    CreateReportMutation.commit({
      name: this.state.name,
    });
    this.setState(Object.assign({}, initialState));
    this.props.onClose();
  };

  cancel = () => {
    this.setState(Object.assign({}, initialState));
    this.props.onClose();
  };

  render() {
    const dialogActions = [
      <FlatButton 
        label="Cancel"
        onTouchTap={this.cancel}
      />,
      <RaisedButton 
        label="Save"
        primary={true}
        onTouchTap={this.save}
      />,
    ];

    return (
      <Dialog
        title="Create a new report"
        open={this.props.open}
        autoScrollBodyContent={true}
        actions={dialogActions}
        onRequestClose={this.props.onClose}
      >
        <TextField
          floatingLabelText="Report Name"
          value={this.state.name}
          onChange={this.updateName}
          style={styles.reportNameInput}
        />
      </Dialog>
    );
  }
}

export default CreateReportDialog;



// WEBPACK FOOTER //
// ./src/scenes/Reports/components/ReportList/components/CreateReportDialog/CreateReportDialog.js